import React, {useContext, useState} from 'react';
import moment from 'moment';
import {Button, Dialog, Grid, useTheme} from "@material-ui/core";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReportSelectionDialogValidator from "../validators/ReportSelectionDialogValidator";
import DateSelector from "../../../controls/DatePicker";
import AircraftLookup from "../../Aircraft/components/AircraftLookup";

const dateFormat = "DD/MM/YYYY";


const ReportSelectionDialog = (props) => {

  const theme = useTheme();
  const [aircraft, setAircraft] = useState(null);
  const [fromDate, setFromDate] = useState(moment().subtract(1,"month").startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().subtract(1,"month").endOf("month").format("YYYY-MM-DD"));

  const [validationState, setValidationStatus] = useState({
    error: false,
    errorMessage: "checking",
    field: null
  });

  const handleClose = () => {
    setAircraft(null);
    if (props.onChange)
      props.onChange(null, null, null);
  };

  const handleSave = () => {
    if (props.onChange && fromDate && toDate) {
      if (aircraft)
        props.onChange(fromDate, toDate, aircraft);
      else
        props.onChange(fromDate, toDate, null);
    } else {
      props.onChange(null);
    }

    setFromDate(null);
    setToDate(null);
    setAircraft(null);
  };


  if (props.open){
    return (
      <div id={"ReportSelectionDialog"}>
        <Dialog open={props.open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            <div style={{clear: "both", backgroundColor:theme.palette.primary.main, padding:"10px"}}>
              Report Selection Criteria
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please select the required date range and aircraft for the report<br/><br/>
            </DialogContentText>
            <Grid container checkChildren={true} spacing={3}>
              <Grid item xs={6} checkChildren={true} row>
                <DateSelector
                  label="From Date"
                  style={{width: "100%"}}
                  value={fromDate}
                  emptyValue={moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD")}
                  disableToolbar={true}
                  autoOk={true}
                  format={dateFormat}
                  onChange={(value) => {
                    setFromDate(moment(value).format("YYYY-MM-DD"));
                    setToDate(moment(value).endOf("month").format("YYYY-MM-DD"));
                  }}
                />
              </Grid>
              <Grid item xs={6} checkChildren={true} row>
                <DateSelector
                  label="To Date"
                  style={{width: "100%"}}
                  value={toDate}
                  emptyValue={moment().format("YYYY-MM-DD")}
                  disableToolbar={true}
                  autoOk={true}
                  format={dateFormat}
                  onChange={(value) => {setToDate(moment(value).format("YYYY-MM-DD"))}}
                />
              </Grid>
              <Grid item xs={12} checkChildren={true} row>
                <AircraftLookup
                  label="Aircraft"
                  id="aircraftReg"
                  inputLabelProps={{shrink: true}}
                  value={aircraft}
                  onChange={(aircraftTailNumber) => setAircraft(aircraftTailNumber)}
                />
              </Grid>
            </Grid>
            <ReportSelectionDialogValidator
              aircraftReg={aircraft}
              fromDate={fromDate}
              toDate={toDate}
              onChange={(validation) => {
                setTimeout(()=> {
                  setValidationStatus(validation);
                },1);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} disabled={validationState.error} color="primary">
              Select
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (<></>);
  }
}

export default ReportSelectionDialog;
